/***********************************************
	IceMedX - Developed By IceMedx Corporation
	Copyright 2011 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';

export class formdocumentation extends IceEntity {
  form_documentation_key: string = "";
  question_identification: string = "";
  question_response: string = "";
  question_reference_identification: string = "";
  response_date: any = NaN;
  percent: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "FORM_DOCUMENTATION";
  }
}


